import React from 'react';
import { useTranslation } from 'react-i18next';
import { MenuItemCard } from './MenuItemCard';
import styles from './MenuItems.module.css';
import { MenuItem } from 'models/digitalMap';
import { AnimatedButton } from 'components/Map/AnimatedButton';

interface Props {
  onClickItem: (item: MenuItem) => void;
  items: MenuItem[];
  id: string;
  title: string;
}

export const MenuItems = React.forwardRef<HTMLElement, Props>(
  ({ onClickItem, items, id, title }, ref) => {
    const { t } = useTranslation();

    return (
      <section ref={ref} id={id} className={styles.section}>
        {title && <h2 className={styles.sectionTitle}>{title}</h2>}
        <div className={styles.itemsContainer}>
          {items.map((item) => {
            return (
              <a onClick={() => onClickItem(item)} key={item.name}>
                <MenuItemCard item={item} />
              </a>
            );
          })}
        </div>
        <AnimatedButton
          className={styles.btn}
          clickedClassName={styles.clicked}
          onClick={() => {
            onClickItem(items[0]);
          }}
        >
          {t('See full menu')}
        </AnimatedButton>
      </section>
    );
  }
);

MenuItems.displayName = 'MenuItems';
